import React from 'react';

import RegistrationPage from '@/features/registration/pages/registration.page';

const RegisterRoute = () => {
  return <RegistrationPage />;
};

export default RegisterRoute;
